import { render, staticRenderFns } from "./nps-question.vue?vue&type=template&id=0a22a5c4"
import script from "./nps-question.vue?vue&type=script&lang=js"
export * from "./nps-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports